var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useIsAside } from '../hooks/use-layout-target';
var cls = classNames('explorer-meta-container');
export var MetaContainerDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var isAside = _a.isAside;
    return isAside && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding: 0 ", ";\n    "], ["\n      padding: 0 ", ";\n    "])), theme.UNIT(6));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var MetaContainer = function (props) {
  var className = props.className,
    children = props.children;
  var isAside = useIsAside();
  return React.createElement(My.Container, {
    isAside: isAside,
    className: cls.name(className)
  }, children);
};
MetaContainer.cls = cls;
MetaContainer.defaultProps = MetaContainerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;